import React, { useState, useEffect } from 'react';
import { Typography, Chip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { CallMade } from '@material-ui/icons';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { asyncFetch } from '../../helperFunctions';
import { resetPasswordAndroidBox, setSnackbar } from '../redux';

const style = { display: 'flex', flexDirection: 'column' };
const textStyle = { margin: '10px' };
export default ({ task }) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const fontSize = width <= 500 ? '4vw' : '20px';
  const [dataResponse, setDataResponse] = useState({
    deviceCount: null,
    email: null,
    isTvContract: null,
    houseHoldId: null,
  });

  useEffect(() => {
    // eslint-disable-next-line consistent-return
    (async () => {
      const response = await asyncFetch(
        `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/androidbox-data`,
        {
          method: 'POST',
          mode: 'cors',
          referrerPolicy: 'strict-origin-when-cross-origin',
          body: JSON.stringify({
            ticketId: task.ticketId,
          }),
        },
        {
          'Content-Type': 'application/json',
        },
        undefined,
        dispatch
      );

      if (response && response.isSuccess) {
        setDataResponse({
          deviceCount: response.deviceCount,
          email: response.email,
          isTvContract: response.isTvContract,
          houseHoldId: response.houseHoldId,
        });
      }
      if (response && response.errorMessage) {
        dispatch(setSnackbar({ open: true, message: response.errorMessage }));
      }
    })();
  }, [dispatch, task.ticketId]);

  return (
    dataResponse.isTvContract &&
    dataResponse.deviceCount > 0 && (
      <div style={style}>
        <Typography style={textStyle}>Email: {dataResponse.email}</Typography>
        <Typography style={textStyle}>
          Брой устройства Android TV: {dataResponse.deviceCount}
        </Typography>
        {dataResponse.houseHoldId && (
          <Chip
            avatar={<CallMade fontSize="small" />}
            label="Смяна на парола за Android TV"
            clickable
            onClick={() =>
              dispatch(
                resetPasswordAndroidBox({ open: true, houseHoldId: dataResponse.houseHoldId })
              )
            }
            style={{ fontSize, margin: '1px', maxWidth: '400px', marginTop: '20px' }}
          />
        )}
      </div>
    )
  );
};
